import { createApi } from '@reduxjs/toolkit/query/react';
import { createBaseQueryWithReauth } from '@api/createBaseQueryWithReauth';

export const oqulyqtarApi = createApi({
    reducerPath: 'oqulyqtarApi',
    baseQuery: createBaseQueryWithReauth(import.meta.env.VITE_OQULYQTAR_API_URL),
    keepUnusedDataFor: 0,
    endpoints: () => ({})
});
